import React from "react";
import { FaReact } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <i>Copyright &copy; 2022 gorniak studio</i>
        <p>
          Website created using Reactjs <FaReact size={20} />
        </p>
      </div>
    </footer>
  );
};

export default Footer;
